import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './index.css';
import App from './App';
import NotFoundHandler from './NotFoundHandler';
import PaslaugosPage from './pages/PaslaugosPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import DukPage from './pages/DukPage';
import GalerijaPage from './pages/GalerijaPage';
import KontaktaiPage from './pages/KontaktaiPage';
import reportWebVitals from './reportWebVitals';

const rootEl = document.getElementById('root');

const tree = (
  <HelmetProvider>
    <Router>
      <Routes>
        {/* Home */}
        <Route path='/'    element={<App lang="lt" />} />
        <Route path='/en'  element={<App lang="en" />} />
        <Route path='/en/' element={<App lang="en" />} />
        <Route path='/ru'  element={<App lang="ru" />} />
        <Route path='/ru/' element={<App lang="ru" />} />

        {/* Services list */}
        <Route path='/paslaugos'     element={<PaslaugosPage lang="lt" />} />
        <Route path='/paslaugos/'    element={<PaslaugosPage lang="lt" />} />
        <Route path='/paslaugos/en'  element={<PaslaugosPage lang="en" />} />
        <Route path='/paslaugos/en/' element={<PaslaugosPage lang="en" />} />
        <Route path='/paslaugos/ru'  element={<PaslaugosPage lang="ru" />} />
        <Route path='/paslaugos/ru/' element={<PaslaugosPage lang="ru" />} />

        {/* Service detail */}
        <Route path='/paslaugos/:slug'     element={<ServiceDetailPage lang="lt" />} />
        <Route path='/paslaugos/:slug/'    element={<ServiceDetailPage lang="lt" />} />
        <Route path='/paslaugos/:slug/en'  element={<ServiceDetailPage lang="en" />} />
        <Route path='/paslaugos/:slug/en/' element={<ServiceDetailPage lang="en" />} />
        <Route path='/paslaugos/:slug/ru'  element={<ServiceDetailPage lang="ru" />} />
        <Route path='/paslaugos/:slug/ru/' element={<ServiceDetailPage lang="ru" />} />

        {/* FAQ */}
        <Route path='/duk'     element={<DukPage lang="lt" />} />
        <Route path='/duk/'    element={<DukPage lang="lt" />} />
        <Route path='/duk/en'  element={<DukPage lang="en" />} />
        <Route path='/duk/en/' element={<DukPage lang="en" />} />
        <Route path='/duk/ru'  element={<DukPage lang="ru" />} />
        <Route path='/duk/ru/' element={<DukPage lang="ru" />} />

        {/* Gallery */}
        <Route path='/galerija'     element={<GalerijaPage lang="lt" />} />
        <Route path='/galerija/'    element={<GalerijaPage lang="lt" />} />
        <Route path='/galerija/en'  element={<GalerijaPage lang="en" />} />
        <Route path='/galerija/en/' element={<GalerijaPage lang="en" />} />
        <Route path='/galerija/ru'  element={<GalerijaPage lang="ru" />} />
        <Route path='/galerija/ru/' element={<GalerijaPage lang="ru" />} />

        {/* Contact */}
        <Route path='/kontaktai'     element={<KontaktaiPage lang="lt" />} />
        <Route path='/kontaktai/'    element={<KontaktaiPage lang="lt" />} />
        <Route path='/kontaktai/en'  element={<KontaktaiPage lang="en" />} />
        <Route path='/kontaktai/en/' element={<KontaktaiPage lang="en" />} />
        <Route path='/kontaktai/ru'  element={<KontaktaiPage lang="ru" />} />
        <Route path='/kontaktai/ru/' element={<KontaktaiPage lang="ru" />} />

        <Route path='*' element={<NotFoundHandler />} />
      </Routes>
    </Router>
  </HelmetProvider>
);

if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}

const preloader = document.getElementById('preloader');
if (preloader) preloader.hidden = true;

reportWebVitals();
